
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"#E9EDF3"}}),_c('path',{attrs:{"d":"M7.25 9.44v-.278c0-.303.03-.572.094-.807.063-.235.161-.446.295-.63a4.08 4.08 0 01.355-.417c.103-.1.253-.231.45-.39.157-.127.276-.228.354-.304.087-.084.182-.189.284-.315.11-.134.19-.277.237-.429.047-.151.07-.323.07-.517 0-.277-.062-.521-.189-.731a1.156 1.156 0 00-.496-.492 1.376 1.376 0 00-.698-.177c-.386 0-.721.126-1.005.379-.276.243-.422.571-.438.983h-1.23c.016-.824.284-1.471.805-1.942a2.717 2.717 0 011.868-.706c.749 0 1.38.244 1.892.731.513.488.769 1.14.769 1.955 0 .303-.032.572-.095.807a2.05 2.05 0 01-.295.644 3.482 3.482 0 01-.355.428c-.103.101-.249.232-.438.391-.165.143-.287.253-.366.328-.071.068-.162.169-.272.303a1.388 1.388 0 00-.225.429c-.04.143-.06.303-.06.48v.277H7.25zM7.177 12v-1.333h1.443V12H7.178z","fill":"#58697D"}})])
          )
        }
      }
    